import React from 'react'
import { motion } from 'framer-motion'
import PillGenerator, { PillData } from './PillGenerator'
import { useI18nContext } from '../../contexts/I18nContext'

interface PillEditorModalProps {
  isOpen: boolean
  onClose: () => void
  onPillChange: (pillData: PillData) => void
  initialPillData?: PillData
}

const PillEditorModal: React.FC<PillEditorModalProps> = ({
  isOpen,
  onClose,
  onPillChange,
  initialPillData
}) => {
  const { t } = useI18nContext()
  const handlePillChange = (pillData: PillData) => {
    onPillChange(pillData)
  }

  if (!isOpen) return null

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      onClick={onClose}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.2 }}
        className="bg-white dark:bg-gray-800 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between rounded-t-lg z-10">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            {t('medication-form-editor')}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-1"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          <PillGenerator
            onPillChange={handlePillChange}
            initialPillData={initialPillData}
          />
        </div>

        {/* Modal Footer */}
        <div className="sticky bottom-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end space-x-3 rounded-b-lg">
          <button
            type="button"
            onClick={onClose}
            className="btn btn-secondary px-4 py-2"
          >
            {t('close')}
          </button>
        </div>
      </motion.div>
    </div>
  )
}

export default PillEditorModal